//
//
//
//
//
//

import ReportsContent from "../Reports/ReportsContent/ReportsContent.vue";

export default {
    name: "SearchPerspectives",
    components: {
        ReportsContent
    },
    computed: {
        dataProps() {
            return {
                customTitle: this.$t("searchPerspectives.title"),
                pageType: "searchPerspectives",
                defaultStateTitle: this.$t("searchPerspectives.defaultStateTile"),
                defaultStateDescription: this.$t("searchPerspectives.defaultStateDescription")
            };
        },
        rndKey() {
            return `search${Math.floor(Math.random() * 100000)}`;
        }
    }
};
